import { render } from "./Subtitles.vue?vue&type=template&id=5952a9be&scoped=true"
import script from "./Subtitles.vue?vue&type=script&lang=ts"
export * from "./Subtitles.vue?vue&type=script&lang=ts"

import "./Subtitles.vue?vue&type=style&index=0&id=5952a9be&lang=scss"
import "./Subtitles.vue?vue&type=style&index=1&id=5952a9be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5952a9be"

export default script